import { render, staticRenderFns } from "./SingleSelection.vue?vue&type=template&id=2da603d5&scoped=true&"
import script from "./SingleSelection.vue?vue&type=script&lang=js&"
export * from "./SingleSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da603d5",
  null
  
)

export default component.exports